function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { Box } from 'native-base';
import React, { memo } from 'react';
const OptionCard = _ref => {
  let {
    children,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    borderRadius: "lg",
    borderWidth: "1",
    borderColor: '#D7D4D4'
  }, rest, {
    p: "4",
    mx: "2",
    bg: "white",
    shadow: "0"
  }), children);
};
export default /*#__PURE__*/memo(OptionCard);
//# sourceMappingURL=index.js.map